module.exports = __webpack_public_path__ + "img/fringe-brush.a7ff9d07.jpg";